import { Flex, Message } from '@lucidhq/lucidium';

interface UnauthorizedMessageProps {
  description?: string;
}

export const UnauthorizedMessage = ({
  description = 'You are not authorized to view this content.',
}: UnauthorizedMessageProps) => (
  <Flex
    lss={{
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
    }}
  >
    <Message
      helper={<>If you need access, please contact our support team.</>}
      message="Unauthorized"
      description={description}
    />
  </Flex>
);
